import React from 'react';
import PropTypes from 'prop-types';

import InvoiceRow from './InvoiceRow';

export default function InvoiceList({ invoices, onResend }) {
  return (
    <div className="invoice-list">
      <div className="invoice-list__header">
        <h5>INVOICES</h5>
      </div>

      <div className="invoice-list__content">
        <table>
          <thead>
            <tr>
              <th>BILLING PERIOD</th>
              <th>DUE ON</th>
              <th>AMOUNT</th>
              <th>STATUS</th>
              <th />
              <th />
            </tr>
          </thead>
          <tbody>
            {invoices.length ? (
              invoices.map((invoice) => {
                return (
                  <InvoiceRow
                    key={invoice.invoice_number}
                    invoice={invoice}
                    onResend={onResend}
                  />
                );
              })
            ) : (
              <tr>
                <td colSpan="6">No Invoices Found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

InvoiceList.defaultProps = {
  invoices: [],
  onResend: () => {},
};

InvoiceList.propTypes = {
  invoices: PropTypes.arrayOf(PropTypes.object),
  onResend: PropTypes.func,
};
